// ==============================|| OVERRIDES - INPUT BASE ||============================== //

export default function InputBase(theme) {
  return {
    MuiInputBase: {
      styleOverrides: {
        root: {
          '& input::placeholder': {
            opacity: 1,
            color: theme.vars.palette.text.secondary
          }
        }
      }
    }
  };
}
